/// <reference path="../../../../../typings/browser.d.ts" />


namespace Application.Controllers {
    'use strict';

    import IStickyConnection = Models.IStickyConnection;
    import ConnectionType = Application.Models.ConnectionType;

    export interface IPresetPathSettingsModalScope extends ng.IScope {
        modalClose: () => void;
        modalSave: () => void;
        newPassword: string;
        name: string;
        updatingPass: (newPassphrase: string)=> void;
        passphraseError: boolean;
        isTsoip: boolean;
    }

    export class PresetPathSettingsModalController {
        public static templateURL: string = "decorators/modals/admin/preset-paths/preset-path-settings.html";
        public static ID: string = "#id-preset-path-settings";
        public static $name: string = "presetPathSettingsModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'presetPathService', 'stickyConnection', 'presetPathType'];

        private $scope: IPresetPathSettingsModalScope;
        private close: (result: string) => void;
        private $timeout: ng.ITimeoutService;
        private stickyConnection: IStickyConnection;

        /**
         * Constructor
         */
        constructor($scope: IPresetPathSettingsModalScope,
                    close: (result: string) => void,
                    $timeout: ng.ITimeoutService,
                    private presetPathService: Services.PresetPathService,
                    stickyConnection: IStickyConnection,
                    presetPathType: string) {

            $timeout(() => {
                window.altair_forms_validation();
            }, 500);

            this.$scope = $scope;
            this.close = close;
            this.$timeout = $timeout;
            this.stickyConnection = stickyConnection;
            this.$scope.name = this.stickyConnection.name;
            this.$scope.passphraseError = false;
            
            this.$scope.isTsoip = presetPathType === ConnectionType.TSOIP;

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.updatingPass = (newPassphrase: string): void => {
                let emptyPassphrase: boolean = newPassphrase == undefined || newPassphrase.length === 0;
                let charValidation: boolean = newPassphrase.indexOf('=') !== -1 || newPassphrase.indexOf('&') !== -1 || newPassphrase.indexOf('?') !== -1;
                if(!this.$scope.isTsoip && !emptyPassphrase && (newPassphrase.length > 9 && newPassphrase.length < 81 && !charValidation)){
                    this.$scope.passphraseError = false;
                    this.$scope.newPassword = newPassphrase;
                }else{
                    this.$scope.passphraseError = true;
                }
            }

            this.$scope.modalSave = (): void => {
                const newPassword: string = this.$scope.newPassword;
                const name: string = this.$scope.name;

                const canUpdate: boolean = this.$scope.isTsoip || (newPassword && newPassword !== '') || (name && name !== '');

                if (canUpdate) {
                    this.presetPathService.updatePresetPathPassword(this.stickyConnection.id, newPassword, name)
                        .then(() => {
                            this.close(newPassword);
                        })
                        .catch(reason => {
                            Common.Utils.alertOnError('Error: '+reason.data.message, 'bottom-center');
                        }
                    )
                }

            };
        }
    }
}
